var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpandTree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.35323 5.97945L4.99967 5.6259L4.29257 6.33301L4.64612 6.68656L5.35323 5.97945ZM6.99967 8.33301L6.64612 8.68656L6.99967 9.04011L7.35323 8.68656L6.99967 8.33301ZM9.35323 6.68656L9.70678 6.33301L8.99967 5.6259L8.64612 5.97945L9.35323 6.68656ZM4.64612 6.68656L6.64612 8.68656L7.35323 7.97945L5.35323 5.97945L4.64612 6.68656ZM7.35323 8.68656L9.35323 6.68656L8.64612 5.97945L6.64612 7.97945L7.35323 8.68656ZM11.1663 6.99967C11.1663 9.30086 9.30086 11.1663 6.99967 11.1663L6.99967 12.1663C9.85314 12.1663 12.1663 9.85315 12.1663 6.99967H11.1663ZM6.99967 2.83301C9.30086 2.83301 11.1663 4.69849 11.1663 6.99967H12.1663C12.1663 4.1462 9.85315 1.83301 6.99967 1.83301V2.83301ZM2.83301 6.99967C2.83301 4.69849 4.69849 2.83301 6.99967 2.83301V1.83301C4.1462 1.83301 1.83301 4.1462 1.83301 6.99967L2.83301 6.99967ZM1.83301 6.99967C1.83301 9.85314 4.1462 12.1663 6.99967 12.1663L6.99967 11.1663C4.69849 11.1663 2.83301 9.30086 2.83301 6.99967L1.83301 6.99967Z",
    fill: "#595D62"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandTree);
export default __webpack_public_path__ + "static/media/expand-tree.b5a1266216fa3b4fbeb7e3b4d628bc4a.svg";
export { ForwardRef as ReactComponent };